import Err from "../../../routes/error";
import { unsubscribe } from "../api/marketing-unsubscribe-api";
import { showToast } from "@Shared/@Utils/constants";
export const SUBMIT_UNSUBSCRIBE = "SUBMIT_UNSUBSCRIBE";
const actions = {
  [SUBMIT_UNSUBSCRIBE]: async (context, {
    unsubscribeOption,
    type,
    token
  }) => {
    try {
      const payload = {
        unsubscribeOption,
        type,
        token,
        subscribed: false
      };
      await unsubscribe(payload);
      showToast("success", "cancelledYourSubscription");
    } catch (e) {
      Err.handle(e, {}, "errorCancellingYourSubscription");
    }
  }
};
export default actions;